import React from "react"
import Layout from "../layouts/layout"
import Section from "../components/section/section"
import SectionHeading from "../components/sectionHeading/sectionHeading"
import aboutImage from "../images/aboutImage.svg"
import AboutText from "../components/aboutText/aboutText"
import Button from "../components/button/button"
import TeamPhoto from "../components/teamPhoto/teamPhoto"

const pageMetaData = {
  title: "Koodoo | About",
  description:
    "We’re powering the future of mortgages and creating a world where securing home financing is seamless and transparent",
  URL: "https://koodoo.io/about",
}

const About = () => {
  return (
    <Layout
      pageTitle={pageMetaData.title}
      pageDescription={pageMetaData.description}
      pageURL={pageMetaData.URL}
      headerWhiteText
    >
      <Section hero="small" alignment="left" image={aboutImage}>
        <h1>We’re powering the future of mortgages</h1>
      </Section>
      <Section color="grey">
        <AboutText
          title="Our vision"
          text={[
            {
              id: 1,
              content:
                "Our vision is a world where securing home financing is seamless and transparent.",
            },
            {
              id: 2,
              content:
                "We believe that people want homes, not lengthy mortgage applications they don’t understand.",
            },
          ]}
        />
        <AboutText
          title="Our business"
          text={[
            {
              id: 1,
              content:
                "We make mortgages simple by partnering with leading lenders and aggregators to intelligently connect borrowers to their next mortgage.",
            },
          ]}
        />
        <AboutText
          title="Our investors"
          text={[
            {
              id: 1,
              content:
                "We’re backed by Blenheim Chalcot, the UK’s leading digital venture builder.",
            },
          ]}
        />
      </Section>
      <TeamPhoto />
      <Section color="grey">
        <AboutText
          title="Our team"
          text={[
            {
              id: 1,
              content:
                "Co-founded by Dan Cobley, former head of Google in the UK and Ireland, Koodoo brings together a team of world-class designers, developers, data scientists, mortgage experts, and business builders from successful startups and big businesses. Together, we’re transforming the mortgage industry.",
            },
          ]}
        />
      </Section>
      <Section>
        <SectionHeading orphan>
          <h2>Careers</h2>
          <p>
            We’re looking for bright and dedicated people that are ready for a
            challenge.
          </p>
          <p>
            We are hiring a range of software development professionals to join
            our team. Send your CV over to{" "}
            <a href="mailto:hello@koodoo.io">hello@koodoo.io</a> to register
            your interest and we will be in touch.
          </p>
          <p>Alternatively, click below to see job descriptions</p>
          <Button type="primary" link="/careers">
            Open Roles
          </Button>
        </SectionHeading>
      </Section>
    </Layout>
  )
}

export default About
